<template>
  <v-combobox
    v-model="model"
    :filter="filter"
    :hide-no-data="!search"
    :items="items"
    :search-input.sync="search"
    hide-selected
    label="Values"
    placeholder="Add new values"
    multiple
    small-chips
    outlined
    filled
    single-line
    hide-details
  >
    <template v-slot:no-data>
      <v-list-item>
        <span class="subheading mr-1">Create</span>
        <v-chip color="cyan lighten-3" label small>{{ search }}</v-chip>
        <span class="body-2 ml-5 mr-1">(Press</span>
        <v-chip dark color="black" label x-small>ENTER</v-chip>
        <span class="body-2">)</span>
      </v-list-item>
    </template>
    <template v-slot:selection="{ attrs, item, parent, selected }"></template>
    <template v-slot:item="{ item }">
      <v-text-field
        v-if="editingItem === item"
        v-model="editing"
        autofocus
        flat
        background-color="transparent"
        hide-details
        solo
        @keyup.enter="edit(item)"
      ></v-text-field>
      <v-chip v-else color="blue lighten-3" dark label small>{{ item }}</v-chip>
      <v-spacer></v-spacer>
      <v-list-item-action @click.stop>
        <v-btn icon @click.stop.prevent="edit(item)">
          <v-icon>{{ editingItem !== item ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
        </v-btn>
        <v-btn icon @click.stop.prevent="remove(item)" v-if="editingItem === item">
          <v-icon>{{ 'mdi-close' }}</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    items: Array
  },
  data() {
    return {
      editing: null,
      editingItem: null,
      nonce: 1,
      menu: false,
      model: [],
      search: null
    };
  },
  watch: {
    model(val, prev) {
      if (val.length === prev.length) return;

      this.model = val.map(v => {
        if (typeof v === "string") {
          var newItem = v.toUpperFirstLetter();
          if (!this.items.includes(newItem)) {
            this.items.push(newItem);
          }
          this.nonce++;
        }
        return newItem;
      });
      this.model = [];
    }
  },
  computed: {},
  methods: {
    edit(item) {
      if (!this.editing) {
        this.editing = item;
        this.editingItem = item;
      } else {
        var index = this.items.indexOf(this.editingItem);
        this.items.splice(index, 1, this.editing);
        this.editing = null;
        this.editingItem = null;
      }
    },
    remove(item) {
      var index = this.items.indexOf(item);
      this.items.splice(index, 1);
      this.editing = null;
      this.editingItem = null;
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    }
  }
};
</script>
